import axios from "../axios";
import { encodeQueryFilter } from "./utils";

const PATIENTS_URL = "/api/patients";

export function fetchPatients(filter?: any) {
  let url = PATIENTS_URL;
  if (filter) {
    url += `?filter=${encodeQueryFilter(filter)}`;
  }
  return axios({
    url,
    method: "get",
  });
}

export function fetchPatient(id: string) {
  return axios({
    url: `${PATIENTS_URL}/${id}`,
    method: "get",
  });
}

export function editPatient(data: any, patientId: string) {
  const formData = new FormData();
  const patientDataChanged =
    data?.patient && Object.entries(data?.patient).length !== 0;
  if (patientDataChanged) {
    formData.append("patient", JSON.stringify(data.patient));
  }
  if (data?.frontImage) {
    formData.append("frontImage", data.frontImage);
  }
  if (data?.backImage) {
    formData.append("backImage", data.backImage);
  }

  return axios({
    url: PATIENTS_URL + `/update-binary-data/${patientId}`,
    method: "put",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
}
